var English = "الإنجليزية";
var French = "الفرنسية";
var German = "الألمانية";
var Italian = "الإيطالية";
var Japanese = "اليابانية";
var Korean = "الكورية";
var Portuguese = "البرتغالية";
var Russian = "الروسية";
var Spanish = "الإسبانية";
var Bahasa = "الإندونيسية الرسمية";
var Thai = "التايلاندية";
var Vietnamese = "الفيتنامية";
var Turkish = "التركية";
var Arabic = "العربية";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "الصينية المبسطة",
	"Chinese-Traditional": "الصينية التقليدية",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
